import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-quote-card',
  imports: [],
  templateUrl: './quote-card.component.html',
  styleUrl: './quote-card.component.scss'
})
export class QuoteCardComponent {
  @Input() title = '';
  @Input() arabic = '';
  @Input() translation = '';
  @Input() reference = '';
}
